import queryString from 'query-string'
import 'whatwg-fetch'

const _getData = (url, params, slashParams = false) => {
    let _params = slashParams ?
        params.map(p => `/${p}`).join('') :
        queryString.stringify(params)

    return fetch(`${url}${_params}`);
}

const _postData = (url, params) => {
    return fetch(url, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: "POST",
        body: queryString.stringify(params)
    });
}

const jsonPipe = response => response.json();


export {
    _getData,
    _postData,
    jsonPipe
}


// WEBPACK FOOTER //
// ./src/Components/Services/Fetch/fetch.js